module.exports = __webpack_public_path__ + "img/talk_1.3ed6cd77.png";